import { useState } from 'react';
import EmailSenderTab from './EmailSenderTab';
import NotificationsTab from './NotificationsTab';
import NotificationRulesTab from './NotificationRulesTab';
import EmailTemplatesTab from './EmailTemplatesTab';

const EMAIL_TABS = [
	{ id: 'sender', label: 'Sender' },
	{ id: 'notifications', label: 'Notifications' },
	{ id: 'rules', label: 'Rules' },
	{ id: 'templates', label: 'Templates' },
];

export default function EmailTabs({ storeId }) {
	const [tab, setTab] = useState('sender');

	return (
		<div>
			<div className='flex gap-6 border-b border-gray-200 mb-6'>
				{EMAIL_TABS.map((t) => (
					<button
						key={t.id}
						type='button'
						onClick={() => setTab(t.id)}
						className={`pb-3 text-sm ${
							tab === t.id
								? 'border-b-2 border-black text-black font-medium'
								: 'text-gray-500 hover:text-black'
						}`}
					>
						{t.label}
					</button>
				))}
			</div>

			{tab === 'sender' && <EmailSenderTab storeId={storeId} />}
			{tab === 'notifications' && <NotificationsTab storeId={storeId} />}
			{tab === 'rules' && <NotificationRulesTab storeId={storeId} />}
			{tab === 'templates' && <EmailTemplatesTab storeId={storeId} />}
		</div>
	);
}
